import termsAndConditions from "../../api/termsAndConditions";

export default {
  namespaced: true,
  state: {
    items: [],
    editedId: -1,
    accepted: false,
    acceptances: [],
    editedItem: {
      versionNumber: "",
      versionDate: "",
      fullText: "",
      changeDescription: "",
      isActive: true,
    },
    defaultItem: {
      versionNumber: "",
      versionDate: "",
      fullText: "",
      changeDescription: "",
      isActive: true,
    },
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setAccepted(state, acceptedOrNot) {
      state.accepted = acceptedOrNot;
    },
    setEditedItem(state, item) {
      const editedItem = {
        versionNumber: item.versionNumber,
        versionDate: item.versionDate,
        fullText: item.fullText,
        changeDescription: item.changeDescription,
        isActive: item.isActive,
      };
      state.editedItem = editedItem;
    },
    setEditedId(state, id) {
      state.editedId = id;
    },
    setAcceptances(state, acceptances) {
      state.acceptances = acceptances;
    },
  },
  actions: {
    fetchAll({ commit }, data) {
      return termsAndConditions.get(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    userAccepted({ commit }, data) {
      return termsAndConditions.acceptedOrNot(data).then((response) => {
        commit("setAccepted", response.data);
        return response;
      });
    },
    getCurrent({ commit }) {
      return termsAndConditions.getCurrent().then((response) => {
        commit("setEditedItem", response.data);
        commit("setEditedId", response.data.id);
        return response;
      });
    },
    userConfirmation({ commit }, data) {
      return termsAndConditions.acceptConditions(data).then((response) => {
        commit("setAccepted", true);
        return response;
      });
    },
    getUserAcceptanceList({ commit }, id) {
      return termsAndConditions.getUserAcceptanceList(id).then((response) => {
        commit("setAcceptances", response.data);
        return response;
      });
    },
    saveEditedItem({ dispatch, state }) {
      const data = {
        versionNumber: state.editedItem.versionNumber,
        fullText: state.editedItem.fullText,
        changeDescription: state.editedItem.changeDescription,
        isActive: state.editedItem.isActive,
      };
      return termsAndConditions.store(data).then((response) => {
        dispatch("fetchAll");
        dispatch("resetEditedItem");
        return response;
      });
    },
    updateEditedItem({ dispatch, state }) {
      return termsAndConditions
        .update(state.editedId, state.editedItem)
        .then((response) => {
          dispatch("fetchAll");
          dispatch("resetEditedItem");
          return response;
        });
    },
    resetEditedItem({ commit, state }) {
      commit("setEditedId", -1);
      commit("setEditedItem", Object.assign({}, state.defaultItem));
    },
  },
};
